import { Flex } from "components/Flex";
import { Pagination } from "components/Pagination";
import { UsersList } from "components/UsersList/UsersList";
import { useSearchContext } from "contexts/SearchContactContext";
import { useContacts } from "hooks/contacts";
import { usePagination } from "hooks/pagination";
import React, { useRef } from "react";

export const ContactsMyView = () => {
  const { query } = useSearchContext();
  const { contacts, retrieveContacts, pagination } = useContacts({
    filterQuery: query,
  });
  const usersListRef = useRef<HTMLDivElement>(null);

  const { handleChangePage } = usePagination({
    paginatedElRef: usersListRef,
    updateFn: (pageNumber) => {
      retrieveContacts({
        page: pageNumber,
      });
    },
  });

  return (
    <div ref={usersListRef}>
      <UsersList items={contacts} />
      <Flex justifyContent="flex-end" mt={6}>
        <Pagination
          current={pagination.current}
          pages={pagination.pages}
          onPageClick={handleChangePage}
        />
      </Flex>
    </div>
  );
};
